import React, { useCallback, useState } from "react";
import { useIntl } from 'react-intl';
import { db } from "../../../db/db";
import { useLiveQuery } from 'dexie-react-hooks';
import ModalConfigs from '../../Modals/ModalConfigs';
import { DivSelectLangStyle } from "./styles";
import ModalEditAccount from "../../Modals/ModalEditAccount";
import ModalReviewTutorials from "../../Modals/ModalReviewTutorials";
import { editAccount, getTutorials } from "../../../services";
import { useOutsideClick } from "../../../hooks/use-outside-click";
import { terminateIokSession } from "../../../integrations/iokSessionLifecycle";

const SelectLang = () => {
  const intl = useIntl();
  const [signingOut, setSigningOut] = useState(false);
  const [showDropdown, setShowDropdown] = useState<boolean>(false);
  const wrapperRef = useOutsideClick(() => setShowDropdown(false))
  const [showModalConfigs, setShowModalConfigs] = useState<boolean>(false);
  const [showModalEditAccount, setShowModalEditAccount] = useState<boolean>(false);
  const [showModalReviewTutorials, setShowModalReviewTutorials] = useState<boolean>(false);
  const userDb = useLiveQuery(() => db.user.toArray())
  const userConfigsDb = useLiveQuery(() => db.userConfigs.toArray())
  const companyDb = useLiveQuery(() => db.company.toArray())

  const editAccountHandler = () => {
    setShowDropdown(false);
    setShowModalEditAccount(true);
  };
  const configHandler = () => {
    setShowDropdown(false);
    setShowModalConfigs(true);
  };
  const tutorialsHandler = () => {
    setShowDropdown(false);
    setShowModalReviewTutorials(true);
  };

  const updateToken = async (signal: AbortSignal) => {
    if (!userDb?.[0]) return;
    const submit = {
      user: {
        id: userDb[0].id,
        accessToken: null
      }
    };
    await editAccount(submit, userDb[0].accessToken, signal);
  };

  const signOutHandler = async () => {
    if (signingOut) return;
    setSigningOut(true);
    setShowDropdown(false);
    await terminateIokSession({
      reason: 'logout',
      publicPath: '/login',
      beforeClear: updateToken
    });
  };

  const handleConfirmReviewTutorials = useCallback(async () => {
    try {
      const id: number = (userConfigsDb ? (userConfigsDb[0]?.id ?? 1) : 1);
      const tutorialsDataResponse = await getTutorials(userDb?.[0]?.id ?? 1, userDb?.[0].accessToken ?? '');
      db.userConfigs.update(id, { id, tutorialsUnmade: tutorialsDataResponse.data });
    } catch (error) {
      console.error(error)
    }
  }, [userDb, userConfigsDb])

  return (
    <DivSelectLangStyle id="joyride-user-name" ref={wrapperRef}>
      {showModalConfigs && (
        <div className="modal">
          <ModalConfigs onCancel={() => setShowModalConfigs(false)} userConfigsDb={userConfigsDb ? userConfigsDb[0] : ''} />
        </div>
      )}

      {showModalEditAccount && (
        <div className="modal">
          <ModalEditAccount user={userDb ? userDb[0] : ""} onCancel={() => setShowModalEditAccount(false)} />
        </div>
      )}

      {showModalReviewTutorials && (
        <div className="modal">
          <ModalReviewTutorials idUser={userDb?.[0]?.id ?? 0} token={userDb?.[0].accessToken ?? ''} onUpdateList={handleConfirmReviewTutorials} onCancel={() => setShowModalReviewTutorials(false)} />
        </div>
      )}

      <p className="selected" aria-busy={signingOut} onClick={() => !signingOut && setShowDropdown((prevState) => !prevState)}>
        <span role="status">{signingOut ? intl.formatMessage({ id: 'session.signingOut' }) : userDb?.[0]?.userName ?? ""}</span>
        <span className={showDropdown ? 'up-arrow' : 'down-arrow'}></span>
      </p>
      {showDropdown && (
        <ul className="dropdown">
          <p>{companyDb && companyDb[0].corporateName}</p>
          <p>ID: {companyDb && companyDb[0].id}</p>
          <li className="notShowMobile" onClick={editAccountHandler}>{intl.formatMessage({ id: 'main.Editar conta' })}</li>
          <li className="notShowMobile" onClick={configHandler}>{intl.formatMessage({ id: 'main.Configurações' })}</li>
          {companyDb && (companyDb[0].companyType !== 'Suporte' && companyDb[0].companyType !== 'Master' && companyDb[0].companyType !== 'Analytics') && <li className="notShowMobile" onClick={tutorialsHandler}>{intl.formatMessage({ id: 'main.Rever tutoriais' })}</li>}
          <li className="notShowMobile" onClick={signOutHandler}>{intl.formatMessage({ id: 'navbar.logout' })}</li>
        </ul>
      )}
    </DivSelectLangStyle>
  );
};

export default SelectLang;
